<!--搜索框，自动添加label-->
<template>
  <div class="vm-search-com">
    <div :style="labelStyle" class="vm-search-label">
      {{label}}
    </div>
    <slot/>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      labelWidth: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      labelStyle: function() {
        return {
          width: this.labelWidth === 0 ? "auto" : this.labelWidth + "px",
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
.vm-search-com {
  display: inline-flex;
  margin: 2px 5px 2px 5px;
  float: left;
  width: 320px;

  .vm-search-label {
    box-sizing: border-box;
    display: inline-block;
    font-size: 13px;
    color: #333;
    line-height: 28px;
    white-space: nowrap;
    text-align: right;
  }

  ::v-deep .el-select,
  .el-input {
    flex: 1;
    width: 100%;
  }
}
</style>
